import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useSelector } from 'react-redux';

import { NEWBUILDING_MORTGAGE_CALCULATOR_MF_NAME } from 'shared/constants/microfrontends';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectNewbuildingMortgageCalculatorMicrofrontEnabled } from 'shared/selectors/featureToggle';

interface IAvailableResult {
  isAvailable: true;
  manifest: IMicrofrontendManifest;
}

interface INotAvailableResult {
  isAvailable: false;
  manifest: null;
}

export function useNewbuildingMortgageCalculatorMicrofront(): IAvailableResult | INotAvailableResult {
  const isCalculatorMicrofrontendEnabled = useSelector(selectNewbuildingMortgageCalculatorMicrofrontEnabled);

  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(
    `microfrontendManifests.${NEWBUILDING_MORTGAGE_CALCULATOR_MF_NAME}`,
  );

  if (isCalculatorMicrofrontendEnabled && manifest) {
    return {
      isAvailable: true,
      manifest,
    };
  }

  return {
    isAvailable: false,
    manifest: null,
  };
}
